enum ActionTypes {
  JOBS_SUBMITTED= "JOBS_SUBMITTED",
  DOWNLOADED_PRODUCTS = "DOWNLOADED_PRODUCTS"
}
export default ActionTypes;
